module.exports = __webpack_public_path__ + "img/pin-private.dc86ca31.png";